import {
  ADDRESS_TYPES as SharedADDRESS_TYPES,
  ALL_ADDRESS_TYPES as SharedALL_ADDRESS_TYPES,
} from "shared/dist/types/Address";

import type {
  Address as SharedAddress,
  AddressType as SharedAddressType,
} from "shared/dist/types/Address";

export type AddressType = SharedAddressType;
export const ADDRESS_TYPES = SharedADDRESS_TYPES;
export const ALL_ADDRESS_TYPES = SharedALL_ADDRESS_TYPES;

export default interface Address extends SharedAddress {}
